// extracted by mini-css-extract-plugin
export var addressFields = "_7z-0";
export var animationContainer = "_7z-1";
export var footer = "_7z-2";
export var lineItems = "_7z-3";
export var modalContent = "_7z-4";
export var orderName = "_7z-5";
export var strong = "_7z-6";
export var warning = "_7z-7";